import React from 'react'
import MonthHeader from './MonthHeader'
import MonthDates from './MonthDates'
import WalkingPanda from '../../../common/LoadingIndicators/WalkingPanda'
import useInitLoader from '../useInitLoader'

export default function MonthView({
  onClickEvent = () => {},
  onNavigate = () => {},
  handleSidebarData = () => {},
  showSidebar,
  events,
  selectedDate,
  willLoad = true,
}) {
  const [showLoader] = useInitLoader(events.isLoading)
  return (
    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
      <MonthHeader />
      {<WalkingPanda hidden={!events.isLoading} style={{top: 80, paddingTop: 120}} />}
      <MonthDates
        onClickEvent={onClickEvent}
        showSidebar={showSidebar}
        handleSidebarData={handleSidebarData}
        onNavigate={onNavigate}
        events={events}
        selectedDate={selectedDate}
      />
    </div>
  )
}
